import { Integration, SDK } from '@commercetools/frontend-sdk';
import { getProjectActions, ProjectActions } from './actions/ProjectActions';
import { getProductActions, ProductActions } from './actions/ProductActions';
import { getCartActions, CartActions } from './actions/CartActions';
import { getWishlistActions, WishlistActions } from './actions/WishlistActions';
import { AccountActions, getAccountActions } from './actions/AccountActions';
import { getAuthorizeNetActions, AuthorizeNetActions } from './actions/AuthorizeNetActions';
import { ComposableCommerceEvents } from '../types/events/ComposableCommerceEvents';
import { getSearchActions, SearchActions } from './actions/SearchActions';
import { BusinessUnitActions, getBusinessUnitActions } from './actions/BusinessUnitActions';
import { AmplienceActions, getAmplienceActions } from './actions/AmplienceActions';

class ComposableCommerce extends Integration<ComposableCommerceEvents> {
  constructor(sdk: SDK<ComposableCommerceEvents>) {
    super(sdk);

    this.project = getProjectActions(sdk);
    this.product = getProductActions(sdk);
    this.cart = getCartActions(sdk);
    this.wishlist = getWishlistActions(sdk);
    this.businessUnit = getBusinessUnitActions(sdk);
    this.account = getAccountActions(sdk);
    this.authorizeNet = getAuthorizeNetActions(sdk);
    this.search = getSearchActions(sdk);
    this.amplience = getAmplienceActions(sdk);
  }

  unregisterExtension(): void {}

  project: ProjectActions;
  product: ProductActions;
  cart: CartActions;
  wishlist: WishlistActions;
  businessUnit: BusinessUnitActions;
  account: AccountActions;
  authorizeNet: AuthorizeNetActions;
  search: SearchActions;
  amplience: AmplienceActions;
}
export { ComposableCommerce };
